import { TooltipDialog } from '../../widgets'

export const PracticeBreakdownDialog = () => (
  <TooltipDialog
    order={0}
    title="See How Your Team Responded"
    text="Each practice has two questions."
    secondText="Click on any blue bar below to see the answer and how many people selected it."
    image="responses"
    buttonText="Next"
  />
)